module.exports = __webpack_public_path__ + "img/6.e129ef3b.jpg";